import { getAuthToken } from '../utils/auth';
import { handleUnauthorized } from '../utils/errorHandler';

const API_BASE_URL = (import.meta as any).env.VITE_BACKEND_BASE_URL;

export interface MatchupPlayer {
  id: string;
  name: string;
  team: string;
  position: string;
  lineupPosition?: string;
  imageUrl?: string;
  weekPoints?: number;
  projected?: number;
  status: 'active' | 'bench' | 'injured-reserve';
  injuryStatus: 'healthy' | 'questionable' | 'doubtful' | 'out' | 'injured-reserve';
}

export interface MatchupTeamDetail {
  id: string;
  name: string;
  logo?: string;
  totalScore: number;
  projected?: number;
  starters: MatchupPlayer[];
  bench: MatchupPlayer[];
}

export interface MatchupDetailData {
  matchupId: string;
  week: number;
  platform: 'yahoo' | 'sleeper';
  isComplete: boolean;
  team1: MatchupTeamDetail;
  team2: MatchupTeamDetail;
}

export interface MatchupDetailResponse {
  matchupDetail: MatchupDetailData;
}

export const fetchMatchupDetail = async (
  leagueId: string, 
  matchupId: string, 
  week: string
): Promise<MatchupDetailData> => {
  const token = getAuthToken();
  
  if (!token) {
    throw new Error('Authentication expired');
  }

  const response = await fetch(
    `${API_BASE_URL}/leagues/${leagueId}/matchups/${matchupId}?week=${week}`, 
    {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    }
  );

  if (response.status === 401) {
    handleUnauthorized();
    throw new Error('UNAUTHORIZED');
  }

  if (!response.ok) {
    throw new Error('Failed to fetch matchup details');
  }

  const data: MatchupDetailResponse = await response.json();
  return data.matchupDetail;
};